import { useTranslation } from 'react-i18next'

import { UseSearchProps, useSearch } from '@pages/IntroducingBroker/Reports/IBReportResultsPage'

import { useWindowResize } from '@utils/domUtils'

import { SortOptions } from '../Table'
import { BaseColumn, BaseColumnCtx } from '../types'

export const VIEW_MORE_ARROW_COL_KEY = 'viewMoreArrow'

export function useTableSearch<
  TSortKeys extends string,
  TData = unknown,
  TCtx extends BaseColumnCtx = BaseColumnCtx
>(args: {
  columns: BaseColumn<TData, TCtx, TSortKeys | typeof VIEW_MORE_ARROW_COL_KEY | undefined>[]
  placeholderKey: string
  searchOptions?: UseSearchProps
}) {
  const { columns, placeholderKey, searchOptions } = args
  const search = useSearch(searchOptions)
  const { t } = useTranslation()
  const isMobile = useWindowResize()

  const tableHeaders: SortOptions<TSortKeys | typeof VIEW_MORE_ARROW_COL_KEY> = columns
    .filter((col) => !isMobile || col.visibleOnMobile)
    .map(
      ({
        id,
        labelKey,
        isNumeric,
        visibleOnMobile,
        visibleOnDesktop = true,
        responsiveWidth,
        width,
        minWidth,
        maxWidth,
      }) => {
        const widths = responsiveWidth
          ? isMobile
            ? responsiveWidth?.mobile ?? {}
            : responsiveWidth?.desktop ?? {}
          : { width, minWidth, maxWidth }

        return {
          id: id,
          name: t(labelKey),
          isNumeric: isNumeric,
          visibleOnMobile: visibleOnMobile,
          visibleOnDesktop: visibleOnDesktop,
          ...widths,
        }
      }
    )

  return {
    ...search,
    sortOptions: tableHeaders,
    placeholder: t(placeholderKey),
  }
}
